import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@design-lab/app";

function init() {
  let container = document.querySelector(".js-design-lab");

  if (!container) {
    container = document.createElement("div");
    document.body.appendChild(container);
  }

  // Read config from data attribute
  const configData = container.getAttribute("data-config");
  const config = configData ? JSON.parse(configData) : {};

  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <App config={config} />
    </React.StrictMode>
  );
}

document.addEventListener("DOMContentLoaded", () => {
  init();
});
